import { useNavigate } from "react-router-dom";
import { TermosUsoStyle } from "./styles"

export const TermosUsoPage = () => {
    const navigate = useNavigate();

    return(
        <TermosUsoStyle>
            <h3>
                SIT, pessoa jurídica de direito privado descreve, através deste documento, as regras de uso do site
                www.sittrade.com.br e qualquer outro site, loja ou aplicativo operado pelo proprietário.
            </h3>
            <h3>
                Ao navegar neste website, consideramos que você está de acordo com os Termos de Uso abaixo.
            </h3>
            <h3>
                Caso você não esteja de acordo com as condições deste contrato, pedimos que não faça mais uso deste 
                website, muito menos cadastre-se ou envie os seus dados pessoais. Se modificarmos nossos Termos de Uso, 
                publicaremos o novo texto neste website, com a data de revisão atualizada. Podemos alterar este documento a 
                qualquer momento. Caso haja alteração significativa nos termos deste contrato, podemos informá-lo por meio das 
                informações de contato que tivermos em nosso banco de dados ou por meio de notificações.
            </h3>
            <h3>
                A utilização deste website após as alterações significa que você aceitou os Termos de Uso revisados. Caso, após a leitura 
                da versão revisada, você não esteja de acordo com seus termos, favor encerrar o seu acesso.
            </h3>
            <h3>
                Seção 1 - Usuário
            </h3>
            <h3>
                A utilização deste website atribui de forma automática a condição de Usuário e implica a plena aceitação de todas 
                as diretrizes e condições incluídas nestes Termos
            </h3>
            <h3>
                Seção 2 - Adesão em conjunto com a Política de Privacidade
            </h3>
            <h3>
                A utilização deste website acarreta a adesão aos presentes Termos de Uso e a versão mais atualizada da Política de Privacidade de SIT.
            </h3>
            <h3>
                Seção 3 - Condições de acesso
            </h3>
            <h3>
                Em geral, o acesso ao website da SIT possui caráter gratuito e não exige prévia inscrição ou registro. Contudo, para usufruir de 
                algumas funcionalidades, o usuário poderá precisar efetuar um cadastro, criando uma conta de usuário com login e senha próprios 
                para acesso. É de total responsabilidade do usuário fornecer apenas informações corretas, autênticas, válidas, completas e 
                atualizadas, bem como não divulgar o seu login e senha para terceiros. Partes deste website oferecem ao usuário a opção de 
                publicar comentários em determinadas áreas. SIT não consente com a publicação de conteúdos que tenham natureza discriminatória, 
                ofensiva ou ilícita, ou ainda infrinjam direitos de autor ou quaisquer outros direitos de terceiros. A publicação de quaisquer 
                conteúdos pelo usuário deste website, incluindo mensagens e comentários, implica em licença não-exclusiva, irrevogável e 
                irretratável, para sua utilização, reprodução e publicação pela SIT no seu website, plataformas e aplicações de internet, 
                ou ainda em outras plataformas, sem qualquer restrição ou limitação.
            </h3>
            <h3>
                Seção 4 - Cookies
            </h3>
            <h3>
                Informações sobre o seu uso neste website podem ser coletadas a partir de cookies. Cookies são informações armazenadas
                diretamente no computador que você está utilizando. Os cookies permitem a coleta de informações tais como o tipo de 
                navegador, o tempo despendido no website, as páginas visitadas, as preferências de idioma, e outros dados de tráfego 
                anônimos. Nós e nossos prestadores de serviços utilizamos informações para proteção de segurança, para facilitar a 
                navegação, exibir informações de modo mais eficiente, e personalizar sua experiência ao utilizar este website, assim 
                como para rastreamento online. Também coletamos informações estatísticas sobre o uso do website para aprimoramento 
                contínuo do nosso design e funcionalidade, para entender como o website é utilizado e para auxiliá-lo a solucionar 
                questões relevantes. Caso não deseje que suas informações sejam coletadas por meio de cookies, há um procedimento 
                simples na maior parte dos navegadores que permite que os cookies sejam automaticamente rejeitados, ou oferece a 
                opção de aceitar ou rejeitar a transferência de um cookie (ou cookies) específico(s) de um site determinado para o 
                seu computador. Entretanto, isso pode gerar inconvenientes no uso do website. As definições que escolher podem 
                afetar a sua experiência de navegação e o funcionamento que exige a utilização de cookies. Neste sentido, rejeitamos 
                qualquer responsabilidade pelas consequências resultantes do funcionamento limitado deste website provocado pela 
                desativação de cookies no seu dispositivo (incapacidade de definir ou ler um cookie).
            </h3>
            <h3>
                Seção 5 - Propriedade Intelectual
            </h3>
            <h3>
                Todos os elementos de SIT são de propriedade intelectual da mesma ou de seus licenciados. 
                Estes Termos ou a utilização do website não concede a você qualquer licença ou direito de uso dos direitos
                de propriedade intelectual da SIT ou de terceiros
            </h3>
            <h3>
                Seção 6 - Links para sites de terceiros
            </h3>
            <h3>
                Este website poderá, de tempos a tempos, conter links de hipertexto que redirecionará você para sites das 
                redes dos nossos parceiros, anunciantes, fornecedores etc. Se você clicar em um desses links para qualquer 
                um desses sites, lembre-se que cada site possui as suas próprias práticas de privacidade e que não somos 
                responsáveis por essas políticas. Consulte as referidas políticas antes de enviar quaisquer Dados Pessoais 
                para esses sites. Não nos responsabilizamos pelas políticas e práticas de coleta, uso e divulgação 
                (incluindo práticas de proteção de dados) de outras organizações, tais como Facebook, Apple, Google, Microsoft, 
                ou de qualquer outro desenvolvedor de software ou provedor de aplicativo, loja de mídia social, sistema operacional, 
                prestador de serviços de internet sem fio ou fabricante de dispositivos, incluindo todos os Dados Pessoais que 
                divulgar para outras organizações por meio dos aplicativos, relacionadas a tais aplicativos, ou publicadas em nossas 
                páginas em mídias sociais. Nós recomendamos que você se informe sobre a política de privacidade e termos de uso de 
                cada site visitado ou de cada prestador de serviço utilizado.
            </h3>
            <h3>
                Seção 7 - Prazos e alterações
            </h3>
            <h3>
                O funcionamento deste website se dá por prazo indeterminado. O website no todo ou em cada uma das suas seções, 
                pode ser encerrado, suspenso ou interrompido unilateralmente por SIT, a qualquer momento e sem necessidade de 
                prévio aviso.
            </h3>
            <h3>
                Seção 8 - Dados pessoais
            </h3>
            <h3>
                Durante a utilização deste website, certos dados pessoais serão coletados e tratados por SIT e/ou pelos Parceiros. 
                As regras relacionadas ao tratamento de dados pessoais de SIT estão estipuladas na Política de Privacidade.
            </h3>
            <h3>
                Seção 9 - Contato
            </h3>
            <h3>
                Caso você tenha qualquer dúvida sobre os Termos de Uso, por favor, entre em contato pelo e-mail 
                marketing@sittrade.com.br
            </h3>
            <h3>
                -
            </h3>
            <h3>
                Política de Privacidade
            </h3>
            <h3>
                A Sit Assessoria e Marketing Ltda, pessoa jurídica de direito privado, com sede na Rua Jandiatuba, 630, Bloco B, Sala 622 - Vila Andrade, São Paulo / SP, inscrita no CNPJ/MF sob o nº 23.097.315/0001-02 (“Empresa” ou “nós”) 
                leva a sua privacidade a sério e zela pela segurança e proteção de dados de todos os seus clientes, parceiros, fornecedores e 
                usuários (“Usuários” ou “você”) do site “www.sittrade.com.br” e qualquer outro site, Loja, aplicativo operado pela Empresa 
                (aqui designados, simplesmente, “Empresa”). Esta Política de Privacidade (“Política de Privacidade”) destina-se a informá-lo 
                sobre o modo como nós utilizamos e divulgamos informações coletadas em suas visitas à nossa Empresa e em mensagens que trocamos 
                com você (“Comunicações”).
            </h3>
            <h3>
                AO ACESSAR A EMPRESA, ENVIAR COMUNICAÇÕES OU FORNECER QUALQUER TIPO DE DADO PESSOAL, VOCÊ DECLARA ESTAR CIENTE E DE 
                ACORDO COM ESTA POLÍTICA DE PRIVACIDADE, A QUAL DESCREVE AS FINALIDADES E FORMAS DE TRATAMENTO DE SEUS DADOS PESSOAIS
                QUE VOCÊ DISPONIBILIZAR NA EMPRESA.
            </h3>
            <h3>
                Esta Política de Privacidade fornece uma visão geral de nossas práticas de privacidade e das escolhas que você 
                pode fazer, bem como direitos que você pode exercer em relação aos Dados Pessoais tratados por nós. Se você tiver 
                alguma dúvida sobre o uso de Dados Pessoais, entre em contato com marketing@sittrade.com.br
            </h3>
            <h3>
                Além disso, a Política de Privacidade não se aplica a quaisquer aplicativos, produtos, serviços, site ou recursos 
                de mídia social de terceiros que possam ser oferecidos ou acessados por meio da Empresa. O acesso a esses links 
                fará com que você deixe a Empresa e possa resultar na coleta ou compartilhamento de informações sobre você por 
                terceiros. Nós não controlamos, endossamos ou fazemos quaisquer representações sobre esses sites de terceiros ou 
                suas práticas de privacidade, que podem ser diferentes das nossas. Recomendamos que você revise a política de 
                privacidade de qualquer site com o qual você interaja antes de permitir a coleta e o uso de seus Dados Pessoais
            </h3>
            <h3>
                Caso você nos envie Dados Pessoais referentes a outras pessoas físicas, você declara ter a competência para fazê-lo 
                e declara ter obtido o consentimento necessário para autorizar o uso de tais informações nos termos desta Política de 
                Privacidade.
            </h3>
            <h3>
                Definições
            </h3>
            <h3>
                Para os fins desta Política de Privacidade:
            </h3>
            <h3>
                “Dados Pessoais” significa qualquer informação que, direta ou indiretamente, identifique ou possa identificar uma 
                pessoa natural, como por exemplo, nome, CPF, data de nascimento, endereço IP, dentre outros;
            </h3>
            <h3>
                “Dados Pessoais Sensíveis” significa qualquer informação que revele, em relação a uma pessoa natural, origem 
                racial ou étnica, convicção religiosa, opinião política, filiação a sindicato ou a organização de caráter religioso,
                filosófico ou político, dado referente à saúde ou à vida sexual, dado genético ou biométrico;
            </h3>
            <h3>
                “Tratamento de Dados Pessoais” significa qualquer operação efetuada no âmbito dos Dados Pessoais, por meio de 
                meios automáticos ou não, tal como a recolha, gravação, organização, estruturação, armazenamento, adaptação ou 
                alteração, recuperação, consulta, utilização, divulgação por transmissão, disseminação ou, alternativamente, 
                disponibilização, harmonização ou associação, restrição, eliminação ou destruição. Também é considerado 
                Tratamento de Dados Pessoais qualquer outra operação prevista nos termos da legislação aplicável;
            </h3>
            <h3>
                “Leis de Proteção de Dados” significa todas as disposições legais que regulem o Tratamento de Dados Pessoais, 
                incluindo, porém sem se limitar, a Lei nº 13.709/18, Lei Geral de Proteção de Dados Pessoais (“LGPD”).
            </h3>
            <h3>
                Uso de Dados Pessoais
            </h3>
            <h3>
                Coletamos e usamos Dados Pessoais para gerenciar seu relacionamento conosco e melhor atendê-lo 
                quando você estiver adquirindo produtos e/ou serviços na Empresa, personalizando e melhorando sua 
                experiência. Exemplos de como usamos os dados incluem:
            </h3>
            <h3>
                Viabilizar que você adquira produtos e/ou serviços na Empresa
            </h3>
            <h3>
                Para confirmar ou corrigir as informações que temos sobre você;
            </h3>
            <h3>
                Para enviar informações que acreditamos ser do seu interesse;
            </h3>
            <h3>
                Para personalizar sua experiência de uso da Empresa;
            </h3>
            <h3>
                Para personalizar o envio de publicidades para você, baseada em seu interesse em nossa Empresa; 
                e Para entrarmos em contato por um número de telefone e/ou endereço de e-mail fornecido. Podemos 
                entrar em contato com você pessoalmente, por mensagem de voz, através de equipamentos de discagem automática, 
                por mensagens de texto (SMS), por e-mail, ou por qualquer outro meio de comunicação que seu dispositivo seja 
                capaz de receber, nos termos da lei e para fins comerciais razoáveis.
            </h3>
            <h3>
                Além disso, os Dados Pessoais fornecidos também podem ser utilizados na forma que julgarmos necessária ou adequada: 
                (a) nos termos das Leis de Proteção de Dados; (b) para atender exigências de processo judicial; (c) para cumprir 
                decisão judicial, decisão regulatória ou decisão de autoridades competentes, incluindo autoridades fora do país de 
                residência; (d) para proteger nossas operações; (e) para proteger direitos, privacidade, segurança nossos, seus ou 
                de terceiros; (f) para detectar e prevenir fraude; (g) permitir-nos usar as ações disponíveis ou limitar danos que 
                venhamos a sofrer; (h) de outros modos permitidos por lei
            </h3>
            <h3>
                A NOSSA LOJA NÃO SE DESTINA A PESSOAS COM MENOS DE 18 (DEZOITO) ANOS E PEDIMOS QUE TAIS PESSOAS NÃO NOS FORNEÇAM 
                QUALQUER DADO PESSOAL
            </h3>
            <h3>
                Não fornecimento de Dados Pessoais
            </h3>
            <h3>
                Você não é obrigado a compartilhar os Dados Pessoais que solicitamos, no entanto, se você optar por não os compartilhar,
                em alguns casos, não poderemos fornecer a você acesso completo à Loja, alguns recursos especializados ou ser capaz de 
                prestar a assistência necessária ou, ainda, viabilizar a entrega do produto ou prestar o serviço contratado por você.
            </h3>
            <h3>
                Dados coletados
            </h3>
            <h3>
                O público em geral poderá navegar na Loja sem necessidade de qualquer cadastro e envio de Dados Pessoais. No entanto, 
                algumas das funcionalidades da Loja poderão depender de cadastro e envio de Dados Pessoais como concluir a 
                compra/contratação do serviço e/ou a viabilizar a entrega do produto/prestação do serviço por nós.
            </h3>
            <h3>
                No contato a Loja, nós podemos coletar:
            </h3>
            <h3>
                Dados de contato. Nome, sobrenome, número de telefone, cidade, Estado e endereço de e-mail; e Informações que você 
                envia. Informações que você envia via formulário (dúvidas, reclamações, sugestões, críticas, elogios etc.). Na 
                navegação geral na Loja, nós poderemos coletar:
            </h3>
            <h3>
                Dados de localização. Dados de geolocalização quando você acessa a Loja;
            </h3>
            <h3>
                Preferências. Informações sobre suas preferências e interesses em relação aos produtos/serviços (quando você nos diz o que eles são ou quando os deduzimos do que sabemos sobre você);
            </h3>
            <h3>
                Dados de navegação na Loja. Informações sobre suas visitas e atividades na Loja, incluindo o conteúdo (e quaisquer anúncios) 
                com os quais você visualiza e interage, informações sobre o navegador e o dispositivo que você está usando, seu endereço IP, 
                sua localização, o endereço do site a partir do qual você chegou. Algumas dessas informações são coletadas usando nossas 
                Ferramentas de Coleta Automática de Dados, que incluem cookies, web beacons e links da web incorporados. Para saber mais, 
                leia como nós usamos Ferramentas de Coleta Automática de Dados no item 7 abaixo;
            </h3>
            <h3>
                Dados anônimos ou agregados. Respostas anônimas para pesquisas ou informações anônimas e agregadas sobre como a Loja é usufruída. Durante nossas operações, 
                em certos casos, aplicamos um processo de desidentificação ou pseudonimização aos seus dados para que seja razoavelmente 
                improvável que você identifique você através do uso desses dados com a tecnologia disponível; e Outras informações que podemos 
                coletar. Outras informações que não revelem especificamente a sua identidade ou que não são diretamente relacionadas a um 
                indivíduo, tais como informações sobre navegador e dispositivo; dados de uso da Loja; e informações coletadas por meio de cookies,
                pixel tags e outras tecnologias
            </h3>
            <h3>
                Ao menos que você informe em algum formulário livre preenchido por você, nós não coletamos Dados Pessoais Sensíveis. Compartilhamento de Dados Pessoais com terceiros 
                Nós poderemos compartilhar seus Dados Pessoais:
            </h3>
            <h3>
                Com a(s) empresa(s) parceira(s) que você selecionar ou optar em enviar os seus dados, dúvidas, perguntas etc., 
                bem como com provedores de serviços ou parceiros para gerenciar ou suportar certos aspectos de nossas operações 
                comerciais em nosso nome. Esses provedores de serviços ou parceiros podem estar localizados nos Estados Unidos, na 
                Argentina, no Brasil ou em outros locais globais, incluindo servidores para homologação e produção, e prestadores de 
                serviços de hospedagem e armazenamento de dados, gerenciamento de fraudes, suporte ao cliente, vendas em nosso nome, 
                atendimento de pedidos, personalização de conteúdo, atividades de publicidade e marketing (incluindo publicidade 
                digital e personalizada) e serviços de TI, por exemplo
            </h3>
            <h3>
                Com terceiros, com o objetivo de nos ajudar a gerenciar a Loja; e Com terceiros, caso ocorra qualquer reorganização, fusão,
                venda, joint venture, cessão, transmissão ou transferência de toda ou parte da nossa empresa, ativo ou capital (incluindo os
                relativos à falência ou processos semelhantes).
            </h3>
            <h3>
                Transferências internacionais de Dados 
            </h3>
            <h3>
                Dados Pessoais e informações de outras naturezas coletadas por nós podem ser transferidos ou acessados por entidades 
                pertencentes ao grupo corporativo das empresas parceiras em todo o mundo de acordo com esta Política de Privacidade.
            </h3>
            <h3>
                Forma de coleta automática de Dados Pessoais  
            </h3>
            <h3>
                Quando você visita a Loja, ela pode armazenar ou recuperar informações em seu navegador, seja na forma de cookies e 
                de outras tecnologias semelhantes. Essas informações podem ser sobre você, suas preferências ou seu dispositivo e 
                são usadas principalmente para que a Loja funcione como você espera. As informações geralmente não o identificam 
                diretamente, mas podem oferecer uma experiência na internet mais personalizada
            </h3>
            <h3>
                De acordo com esta Política de Privacidade, nós e nossos prestadores de serviços terceirizados podemos coletar seus 
                Dados Pessoais de diversas formas, incluindo, entre outros: Por meio do navegador ou do dispositivo: Algumas 
                informações são coletadas pela maior parte dos navegadores ou automaticamente por meio de dispositivos de acesso à 
                internet, como o tipo de computador, resolução da tela, nome e versão do sistema operacional, modelo e fabricante do 
                dispositivo, idioma, tipo e versão do navegador de Internet que está utilizando. Podemos utilizar essas informações 
                para assegurar que a Loja funcione adequadamente
            </h3>
            <h3>
                Uso de cookies:
            </h3>
            <h3>
                Os cookies permitem a coleta de informações tais como o tipo de navegador, o tempo dispendido na Loja, as páginas 
                visitadas, as preferências de idioma, e outros dados de tráfego anônimos. Nós e nossos prestadores de serviços podemos
                utilizar essas informações para, dentre outros, personalizar sua experiência ao utilizar a Loja, assim como para 
                direcionar publicidade para você, de acordo com os seus interesses. Também coletamos informações estatísticas sobre
                o uso da Loja para aprimoramento contínuo do nosso design e funcionalidade.
            </h3>
            <h3>
                Caso não deseje que suas informações sejam coletadas por meio de cookies, você pode configurar os cookies no menu 
                "opções" ou "preferências" do seu browser. Nos links abaixo você encontra mais detalhes sobre como ajustar as 
                preferências de cookies dos navegadores de internet mais populares:
            </h3>
            <h2>
                Google Chrome
            </h2>
            <h2>        
                Mozilla Firefox
            </h2>
            <h2>
                Safari
            </h2>
            <h2>
                Internet Explorer
            </h2>
            <h2>
                Microsoft Edge  
            </h2>
            <h2>
                Opera
            </h2>
            <h3>
                Caso deseje saber um pouco mais sobre os cookies de publicidade e remarketing, que servem para direcionarmos 
                publicidade em função dos interesses de cada usuário e do número de visitas que realizou em nosso site e suas 
                buscas na internet, acesse:
            </h3>
            <h2>
                Facebook
            </h2>
            <h2>
                Google
            </h2>
            <h2>
                Bing
            </h2>
            <h3>
                Uso de pixel tags e outras tecnologias similares: Pixel tags (também conhecidos como Web beacons e GIFs invisíveis) 
                podem ser utilizados para rastrear ações de usuários da Loja (incluindo destinatários de e-mails), medir o sucesso das
                nossas campanhas de marketing e coletar dados estatísticos sobre o uso da Loja e taxas de resposta. Em caso de ter ativa
                a personalização de anúncios em ferramentas como Facebook, Google ou Bing, a informação pode ser usada para mostrar
                anúncios em seus serviços.No caso de você não desejar ser rastreado pode pedir para cada um dos serviços:
            </h3>
            <h2>
                Facebook
            </h2>
            <h2>
                Google
            </h2>
            <h2>
                Bing
            </h2>
            <h3>
                Podemos contratar empresas de publicidade comportamental, para obter relatórios sobre os anúncios da Loja em toda a 
                internet. Para isso, essas empresas utilizam cookies, pixel tags e outras tecnologias para coletar informações sobre
                a sua utilização, ou sobre a utilização de outros usuários, da nossa Loja e de site de terceiros. Nós não somos 
                responsáveis por pixel tags, cookies e outras tecnologias similares utilizadas por terceiros. Você pode configurar
                suas preferências no menu do seu browser. Esteja ciente de que se você mudar de computador ou navegador, ou usar 
                vários computadores ou navegadores, você precisará repetir este processo para cada computador e cada navegador
            </h3>
            <h3>
                Direitos do Usuário
            </h3>
            <h3>
                Você pode, a qualquer momento, requerer: (i) confirmação de que seus Dados Pessoais estão sendo tratados; (ii) 
                acesso aos seus Dados Pessoais; (iii) correções a dados incompletos, inexatos ou desatualizados; (iv) anonimização, 
                bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com o disposto em lei; (v) 
                portabilidade de Dados Pessoais a outro prestador de serviços, contanto que isso não afete nossos segredos industriais
                e comerciais; (vi) eliminação de Dados Pessoais tratados com seu consentimento, na medida do permitido em lei; (vii) 
                informações sobre as entidades às quais seus Dados Pessoais tenham sido compartilhados; (viii) informações sobre a
                possibilidade de não fornecer o consentimento e sobre as consequências da negativa; e (ix) revogação do 
                consentimento. Os seus pedidos serão tratados com especial cuidado de forma a que possamos assegurar a eficácia 
                dos seus direitos. Poderá lhe ser pedido que faça prova da sua identidade de modo a assegurar que a partilha dos 
                Dados Pessoais é apenas feita com o seu titular
            </h3>
            <h3>
                Você deverá ter em mente que, em certos casos (por exemplo, devido a requisitos legais), o seu pedido poderá não ser imediatamente satisfeito, 
                além de que nós poderemos não conseguir atendê-lo por conta de cumprimento de obrigações legais.
            </h3>
            <h3>
                Segurança dos Dados Pessoais
            </h3>
            <h3>
                Buscamos adotar as medidas técnicas e organizacionais previstas pelas Leis de Proteção de Dados adequadas 
                para proteção dos Dados Pessoais na nossa organização. Infelizmente, nenhuma transmissão ou sistema de armazenamento
                de dados tem a garantia de serem 100% seguros. Caso tenha motivos para acreditar que sua interação conosco tenha 
                deixado de ser segura (por exemplo, caso acredite que a segurança de qualquer uma de suas contas foi comprometida), 
                favor nos notificar imediatamente
            </h3>
            <h3>
                Links de hipertexto para outros sites e redes sociais
            </h3>
            <h3>
                A Loja poderá, de tempos a tempos, conter links de hipertexto que redirecionará você para sites das redes dos nossos
                parceiros, anunciantes, fornecedores etc. Se você clicar em um desses links para qualquer um desses sites, lembramos 
                que cada site possui as suas próprias práticas de privacidade e que não somos responsáveis por essas políticas. 
                Consulte as referidas políticas antes de enviar quaisquer Dados Pessoais para esses sites.
            </h3>
            <h3>
                Não nos responsabilizamos pelas políticas e práticas de coleta, uso e divulgação (incluindo práticas de proteção de dados) de outras organizações, tais como Facebook, Apple, Google, Microsoft, ou de qualquer outro 
                desenvolvedor de software ou provedor de aplicativo, Loja de mídia social, sistema operacional, prestador de serviços de 
                internet sem fio ou fabricante de dispositivos, incluindo todos os Dados Pessoais que divulgar para outras organizações por meio 
                dos aplicativos, relacionadas a tais aplicativos, ou publicadas em nossas páginas em mídias sociais. Nós recomendamos que você se 
                informe sobre a política de privacidade de cada site visitado ou de cada ﻿prestador de serviço utilizado.
            </h3>
            <h3>
                Atualizações desta Política de Privacidade
            </h3>
            <h3>
                Se modificarmos nossa Política de Privacidade, publicaremos o novo texto na Loja, com a data de revisão atualizada. 
                Podemos alterar esta Política de Privacidade a qualquer momento. Caso haja alteração significativa nos termos dessa 
                Política de Privacidade, podemos informá-lo por meio das informações de contato que tivermos em nosso banco de dados
                ou por meio de notificação em nossa Loja.
            </h3>
            <h3>
                Recordamos que nós temos como compromisso não tratar os seus Dados Pessoais de forma incompatível com os objetivos 
                descritos acima, exceto se de outra forma requerido por lei ou ordem judicial.    
            </h3>
            <h3>
                Sua utilização da Loja após as alterações significa que aceitou as Políticas de Privacidade revisadas. Caso, após a 
                leitura da versão revisada, você não esteja de acordo com seus termos, favor encerrar o acesso à Loja.
            </h3>
            <h3>
                Pessoa responsável do tratamento dos Dados Pessoais
            </h3>
            <h3>
                Caso pretenda exercer qualquer um dos direitos previstos nesta Política de Privacidade e/ou nas Leis de Proteção
                de Dados, ou resolver quaisquer dúvidas relacionadas ao Tratamento de seus Dados Pessoais, favor contatar-nos através
                do e-mail: marketing@sittrade.com.br.
            </h3>
            <button onClick={() => {
                localStorage.setItem('termos', 'aceito');
                ;// quero voltar na página anterior + /termos
                navigate(-1);
            }}>
                concordo com os termos
            </button>
        </TermosUsoStyle>
    )
}